import React from "react";
import { Button, LottieLoadingIndicator, StandardModal, StandardModalActionGroup, StandardModalDescription, StandardModalSection } from "src/components";
import Delete from "src/img/Delete.svg";
import { LoadingIndicatorButton } from "src/scenes/Survey/components/Utils";

export default function DeleteAudience(props) {
    const { title, subtitle = null, toggleModal, deleteFunction, isLoading, setSelectedAction } = props;
    return (
        <StandardModal
            open={true}
            onClose={toggleModal}
            widthMode="medium"
            title={title}
            footer={(
                <StandardModalActionGroup $pushRight>
                    <Button
                        type="button"
                        onClick={() => {
                            toggleModal();
                            setSelectedAction({});
                        }}
                        width="140px"
                        height="38px"
                        border="1px solid #000"
                        color="#000000"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Cancel
                    </Button>
                    {isLoading ?
                        <LoadingIndicatorButton>
                            <LottieLoadingIndicator height="2rem" width="2rem" margin="5px" containerHeight="2rem" />
                        </LoadingIndicatorButton>
                        :
                        <Button
                            type="button"
                            onClick={() => deleteFunction()}
                            width="140px"
                            height="38px"
                            backgroundColor="#FF3B3B"
                            border="1px solid #FF3B3B"
                            color="#FFFFFF"
                            style={{ borderRadius: "7px", boxShadow: "none" }}
                        >
                            Delete
                        </Button>}
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection style={{ alignItems: "center", textAlign: "center" }}>
                <img src={Delete} height="50px" width="50px" style={{ color: "red", placeSelf: "center" }} />
                {subtitle && (
                    <StandardModalDescription style={{ whiteSpace: "pre-line", textAlign: "center", maxWidth: "100%" }}>
                        {subtitle}
                    </StandardModalDescription>
                )}
            </StandardModalSection>
        </StandardModal>
    );
}
